import { ngReg } from './nglist'

export function charaLimit(inputText, num) {
  return inputText.length > num ? inputText.slice(0, -1) : inputText;
}

export function checkNGWord(text) {
  if (!text) return true;
  
  return !(ngReg().test(text));
}